import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';

export interface SelectInputOption {
  displayName: string;
  value: string;
}

interface Props {
  options: SelectInputOption[] | string[];
  onSelect: (value: any) => void;
  className?: string;
}

function SelectInput({ options, onSelect, className }: Props) {
  const classes = useStyles();

  // @ts-ignore
  const transformedOptions: SelectInputOption[] = options.map(o => {
    if (typeof o === 'string') {
      return { value: o, displayName: o };
    }

    return o;
  });

  return (
    <div className={classNames(classes.root, className)}>
      <MenuList className={classes.menu}>
        {transformedOptions.map(option => (
          <MenuItem key={option.value} onClick={() => onSelect(option.value)}>
            {option.displayName}
          </MenuItem>
        ))}
      </MenuList>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: { maxWidth: 377 },
  menu: { maxHeight: 250, overflowY: 'auto' },
}));

export default SelectInput;
